export const Endpoint = () => `/api/v3/celery/availableperiods`;
export const QueryKey = () => ['v3', 'admin', 'celery', 'periods'] as const;
export type Payload = never;
export type Response = string[];
